var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('taskBrowser',{attrs:{"submissions":_vm.submissions,"projects":_vm.projects,"type":"journal"}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }